import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceResponse } from 'src/app/@shared/interfaces/service-response.interface';
import { Address } from 'src/app/modules/route-planner/interfaces/location/address.interface';
import { LocationRepository } from '../../repositories/location.repository';
import { Coordinate } from '../../interfaces/location/coordinate.interface';
import { City } from '../../interfaces/location/city.interface';
import { ParkAndRide } from '../../interfaces/location/park-and-ride.interface';
import { POIRequest } from '../../components/route-planner-form/forms/source-destination-form/request-poi/request-poi.component';
import { PointOfInterest } from '../../interfaces/location/point-of-interest.interface';
import { Location } from '../../interfaces/route-planning/location.interface';
import { MapLocations } from '../../interfaces/location/map-locations.interface';
import { RavKavStation } from '../../interfaces/location/ravkav-station.interface';
import { StopDetails } from '../../interfaces/location/stop-details.interface';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  constructor(private readonly locationRepository: LocationRepository) { }

  searchCity(cityTerm: string): Observable<ServiceResponse<City[]>> {
    return this.locationRepository.searchCity(cityTerm);
  }

  searchAddress(addressTerm: string): Observable<ServiceResponse<Address[]>> {
    return this.locationRepository.searchAddress(addressTerm);
  }

  getMapLocations(): Observable<ServiceResponse<MapLocations>> {
    return this.locationRepository.getMapLocations();
  }

  getRavKavStations(): Observable<ServiceResponse<RavKavStation[]>> {
    return this.locationRepository.getRavKavStations()
  }

  getMapParkAndGoLots(): Observable<ServiceResponse<ParkAndRide[]>> {
    return this.locationRepository.getMapParkAndGoLots()
  }

  getMapStops(): Observable<ServiceResponse<StopDetails[]>> {
    return this.locationRepository.getMapStops()
  }

  // Old api that is calling here for address by coordinates, we are now using our api


  // getAddressDataByCoordinates(
  //   coordinates: Coordinate
  // ): Observable<ServiceResponse<Address>> {
  //   return this.locationRepository.getAddressDataByCoordinates(coordinates);
  // }

  getParkAndRideLots(): Observable<ServiceResponse<ParkAndRide[]>> {
    return this.locationRepository.getParkAndRideLots()
  }

  sendPointOfInterest(data: POIRequest): Observable<ServiceResponse<string>> {
    return this.locationRepository.sendPointOfInterest(data)
  }

  getPointsOfInterest(): Observable<ServiceResponse<PointOfInterest[]>> {
    return this.locationRepository.getPointsOfInterest()
  }

  getPointOfInterestById(id: number): Observable<ServiceResponse<PointOfInterest>> {
    return this.locationRepository.getPointOfInterestById(id)
  }

}
